import PrepaidCardApi from '@apis/prepaid/PrepaidCardApi';
import {
    GetPrepaidCardTransactionsParams,
    GetPrepaidCardTransactionsResponse,
    PrepaidCardResponse,
    PrepaidCardsResponse,
    UpdatePrepaidCardNameRequest,
} from '@models/prepaidCard';

/** @deprecated PrepaidCardApi 사용 권장 */
class UserPrepaidCardApi {
    static getUserPrepaidCards(): Promise<PrepaidCardsResponse> {
        return PrepaidCardApi.getPrepaidCards();
    }

    static getUserPrepaidCard(userPrepaidCardId: string): Promise<PrepaidCardResponse> {
        return PrepaidCardApi.getPrepaidCard(userPrepaidCardId);
    }

    static getFavoritePrepaidCards(): Promise<PrepaidCardsResponse> {
        return PrepaidCardApi.getFavoritePrepaidCards();
    }

    static getPrepaidCardTransactions(
        id: string,
        params: GetPrepaidCardTransactionsParams,
    ): Promise<GetPrepaidCardTransactionsResponse> {
        return PrepaidCardApi.getPrepaidCardTransactions(id, params);
    }

    static toggleFavorite(id: string): Promise<void> {
        return PrepaidCardApi.toggleFavoritePrepaidCard(id);
    }

    static updatePrepaidCardName(
        id: string,
        request: UpdatePrepaidCardNameRequest,
    ): Promise<void> {
        return PrepaidCardApi.updatePrepaidCardName(id, request);
    }

    static deletePrepaidCard(id: string): Promise<void> {
        return PrepaidCardApi.deletePrepaidCard(id);
    }

    static deleteAllPrepaidCards() {
        return PrepaidCardApi.deleteAllPrepaidCards();
    }
}

export default UserPrepaidCardApi;
